// extracted by mini-css-extract-plugin
export default {"meter":"MeterItem_meter__XDUq6","title":"MeterItem_title__NL18s","value":"MeterItem_value__Jj9uw","bgIconWrapper":"MeterItem_bgIconWrapper__FFGkU"};